import { render } from "./ModifyComponent.vue?vue&type=template&id=282b4ac1&scoped=true"
import script from "./ModifyComponent.vue?vue&type=script&lang=js"
export * from "./ModifyComponent.vue?vue&type=script&lang=js"

import "./ModifyComponent.vue?vue&type=style&index=0&id=282b4ac1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282b4ac1"]])

export default __exports__